import { memo, useMemo } from 'react';

import { Popover, Stack } from '@lyearn/ui';
import { IconTypeEnum } from '@/types/schema';

import { ICON_SETTINGS_COLOR_PICKER_COLOR_CONFIG } from './consts';
import IconSettingsColorPickerButton from './IconSettingsColorPickerButton';
import IconSettingsColorPickerColorList from './IconSettingsColorPickerColorList';
import { IconSettingsColorPickerProps } from './types';

const classes = { Popover: { rounded: 'rounded-16', spacing: 'mt-6 -ms-12' } };

const colorConfig = ICON_SETTINGS_COLOR_PICKER_COLOR_CONFIG;

const IconSettingsColorPicker = (props: IconSettingsColorPickerProps) => {
  const { value, onChange } = props;

  const actions = useMemo(
    () => ({
      onColorChange: (color: string) => {
        onChange({ type: IconTypeEnum.Color, value: color });
      },
    }),
    [onChange],
  );

  if (!colorConfig[value.value]) {
    console.error('[IconSettingsColorPicker]: Invalid Value', { value });
    return null;
  }

  return (
    <Popover>
      <Popover.Button>
        <IconSettingsColorPickerButton colorConfig={colorConfig} value={value} />
      </Popover.Button>
      <Popover.Content classes={classes} position="bottom-start">
        <Stack className="pb-20 pt-16" direction="col" gapY={12}>
          <IconSettingsColorPickerColorList
            colorConfig={colorConfig}
            value={value}
            onChange={actions.onColorChange}
          />
        </Stack>
      </Popover.Content>
    </Popover>
  );
};

export default memo(IconSettingsColorPicker);
